module.exports = __webpack_public_path__ + "static/img/2.77c239be.jpeg";